var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRenewable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 37,
    viewBox: "0 0 38 37",
    width: 38,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#363536",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.5 30.138889h5.833333v3.888889h-5.833333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.611111 33.055556h14.583333v1.944444h-14.583333z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.9722222 31.1111111h-30.13888887l.1046247-.8363202 2.32755085-18.6081242h25.27174782l2.4321755 19.4444444zm-9.0918865-5.9650538.4596512 4.8429909h7.361394l-.6061258-4.8429909zm-10.0321138-12.3566308h-7.58947585l-.61031076 4.8785345h7.73734541zm-1.1020469 11.6088212.5677634-5.9824771h-7.76036284l-.74841536 5.9824771zm1.8483697-11.6088212-.4631386 4.8785345h8.2918563l-.4624412-4.8785345zm8.1125994 0 .4631386 4.8785345h6.9889301l-.6103108-4.8785345zm7.5455334 5.6263441h-7.01125l.5677634 5.9824771h7.1925995l-.7484154-5.9824771zm-7.191902 5.9817802-.5677633-5.9824771h-8.429961l-.5677633 5.9824771zm-10.3871403.7478096-7.96124224-.0174233-.60821826 4.8604142h8.1098093zm.7470204 0-.4596512 4.8429909h10.6298696l-.4596512-4.8429909z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.82239034 14.5833333c-.80578817-.4536128-1.49699617-1.0818157-2.02164884-1.8373713-1.40301009-2.1784542-1.16817787-5.01302114.57470828-6.93707638 1.74288614-1.92405525 4.56839277-2.46794251 6.91490302-1.33106314 2.3465102 1.13687938 3.6412478 3.67701645 3.1686298 6.21651402h-8.14437713l-.2853421 2.2278215z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.43395466 2.40982074 1.50792735.00572734.01145201 3.01515201-1.50792734-.00572734z",
    transform: "matrix(.70710678 -.70710678 .70710678 .70710678 -1.836646 3.406465)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 8.75h2.916667v1.944444h-2.916667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.555556 8.75h2.916667v1.944444h-2.916667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.87789614 14.5295057 3.01515281.011452.00572734 1.507927-3.01515281-.011452z",
    transform: "matrix(.70713146 -.7070821 .7070821 .70713146 -9.818379 6.873556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.6457176 2.85154479 3.0146967.01145029.0057265 1.50769963-3.0146967-.01145029z",
    transform: "matrix(.70710678 -.70710678 .70710678 .70710678 1.885621 11.774533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.777778 0h1.944444v2.916667h-1.944444z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewable);
export default __webpack_public_path__ + "static/media/renewable.4b1e62e3afaf11f1dd16eeb23d30f2ae.svg";
export { ForwardRef as ReactComponent };